import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Supabase client — singleton.
 *
 * The anon key is safe to ship to the browser because RLS on every
 * table restricts reads/writes to the authenticated user. Without a
 * valid JWT, every query returns zero rows and every write is rejected.
 *
 * See supabase/migrations/0001_init.sql for the RLS policies.
 */

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.warn(
    '[vault] Supabase env not configured. Auth and DB calls will fail until VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set.',
  );
}

export const supabase: SupabaseClient = createClient(
  url ?? 'http://localhost',
  anonKey ?? 'placeholder-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      storageKey: 'vault.session',
    },
  },
);

/**
 * Display configuration shown on the welcome screen.
 * Sourced from env so the same build can be repurposed trivially.
 */
export const vaultConfig = {
  displayName: import.meta.env.VITE_VAULT_DISPLAY_NAME ?? 'there',
  email: import.meta.env.VITE_VAULT_USER_EMAIL ?? '',
  domain: import.meta.env.VITE_VAULT_DOMAIN ?? 'your-vault.local',
} as const;